<template>
  <div class="ml-dropdown assign-dropdown" ref="assignDropdown">
    <div
      class="ml-dropdown-toggle"
      @click="toggleDropdown"
      :class="{ disabled: disabled }"
    >
      {{ $t('ADVANCED_SEARCH.OPTIONS') }}
      <span class="arrow">&#9662;</span>
    </div>

    <div v-if="isOpen && !disabled" class="ml-dropdown-menu">
      <div class="ml-dropdown-item" @click="assign_value_clicked">
        <i class="fa fa-file mr-2 color-primary"></i>
        {{ $t('ADVANCED_SEARCH.ASSIGN_VALUES') }}
      </div>
      <div class="ml-dropdown-item" @click="assign_audience_clicked">
        <i class="fa fa-file mr-2 color-primary"></i>
        {{ $t('ADVANCED_SEARCH.ASSIGN_AUDIENCE') }}
      </div>
    </div>


    <AssignAudienceEditorModal
      :is_advanced_search="true"
      :search_options="search_options"
      ref="assign-audience-modal"
      @created="audience_assigned"
    />

    <MemberPropertyAssignEditor
      :is_advanced_search="true"
      ref="assign-attribute-editor-modal"
      @attribute_selected="attribute_selected"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import MemberPropertyAssignEditor from '@/view/components/member_editor_v2/sections/MemberPropertyAssignEditor.vue';
import AssignAudienceEditorModal from '@/view/components/member_editor_v2/sections/member_audience/AssignAudienceEditorModal.vue';


export default {
  name: 'AdvancedSearchAssignDropdown',
  mixins: [toasts],
  props: ['column_names', 'search_options', 'disabled'],
  components: {
    MemberPropertyAssignEditor,
    AssignAudienceEditorModal
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods']),
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    audience_assigned() {
      this.$refs['assign-audience-modal'].hide();
      this.toastr_permanent('success', this.$t('COMMON.OK'), this.$t('AUDIENCE.ASSIGN_JOB_CREATED'));
    },
    assign_audience_clicked() {
      this.isOpen = false;
      this.$refs['assign-audience-modal'].show();
    },
    toggleDropdown() {
      if (!this.disabled) this.isOpen = !this.isOpen;
    },
    onClickOutside(e) {
      if (!this.$refs.assignDropdown.contains(e.target)) {
        this.isOpen = false;
      }
    },
    assign_value_clicked() {
      this.isOpen = false;
      this.$refs['assign-attribute-editor-modal'].show();
    },
    async attribute_selected(item) {
      await this.post_attributes_from_search_options(item);
      this.$refs['assign-attribute-editor-modal'].hide();
    },
    async post_attributes_from_search_options(item) {
      try {
        const res = await axios.post(`/search/member/attributes`, {
          search_options: this.search_options,
          attribute_item: item
        });
        if (res.status === 201) return res.data;

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.UNABLE_TO_SEARCH'));
      } catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.UNABLE_TO_SEARCH'));
      }
      return [];
    }
  }
};
</script>

<style scoped>
.assign-dropdown {
  position: relative;
  max-width: 200px;
}

.ml-dropdown-toggle {
  padding: 10px 14px;
  border: 1px solid #3699ff;
  border-radius: 4px;
  background: white;
  color: #3699ff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  height: 40px;
}

.ml-dropdown-toggle.disabled {
  background-color: #f3f3f3;
  color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

.arrow {
  font-size: 0.75rem;
  margin-left: 8px;
}

.ml-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 500;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
}

.ml-dropdown-item {
  padding: 12px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.ml-dropdown-item:hover {
  background-color: #f3f6f9;
}

.color-primary {
  color: #3699ff;
}
</style>
